// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrophyTwoToneSvg from "@ant-design/icons-svg/es/asn/TrophyTwoTone";
import AntdIcon from '../components/AntdIcon';

var TrophyTwoTone = function TrophyTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrophyTwoToneSvg
  }));
};

TrophyTwoTone.displayName = 'TrophyTwoTone';
export default /*#__PURE__*/React.forwardRef(TrophyTwoTone);